let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("dsiAd"), load("8VYTt")]).then(() => parcelRequire('8V2Yz'));